<div
  *ngFor="let i of [].constructor(chartNumber); index as i"
  class="relative flex items-center justify-center text-align-center"
  [class]="globalSettings.chartMode === 'single' ? 'timeseriesChartFull h-full w-full' : 'timeseriesChart h-[450px] w-full mb-24'"
>
  <div #chartContainer id="timeseriesChart" class="absolute h-full w-full"></div>
  <nz-empty *ngIf="!!emptyCharts[i]" class="absolute" nzNotFoundImage="simple" [nzNotFoundContent]="contentTpl">
    <ng-template #contentTpl>
      <p class="font-semibold pt-0 text-base text-disabled m-0">No data available</p>
      <p class="text-disabled m-0">Try adjusting your time range, resolution, or selection to see results.</p>
    </ng-template>
  </nz-empty>
</div>
